import { ApdmCampaignVersionRef } from './campaign';
import { CouponCampaignPublicViewItem } from './coupon-redemption';

export enum ApdmCouponCampaignStatus {
  Draft = 'draft',
  Scheduled = 'scheduled',
  Active = 'active',
  Paused = 'paused',
  Ended = 'ended',
}

/** Mirror of backend `ApdmCouponCampaignSummary`. */
export interface ApdmCouponCampaignSummary {
  id: string;
  title: string;
  description: string | null;
  status: ApdmCouponCampaignStatus;
  startsAt: string;
  endsAt: string;
  items: CouponCampaignPublicViewItem[];
  /** The scarcest limited item's remaining stock; null when unlimited. */
  stockLeft: number | null;
  redeemedCount: number;
}

export interface ApdmCouponChoicesRequest {
  campaignId: string;
  afterCouponCampaignId: string | null;
  limit: number;
}

export interface ApdmCouponChoicesResult {
  selectedCouponCampaignId: string | null;
  coupons: ApdmCouponCampaignSummary[];
  nextAfterCouponCampaignId: string | null;
}

/** Null sends the campaign without a coupon. */
export interface ApdmSetCampaignCouponInput extends ApdmCampaignVersionRef {
  couponCampaignId: string | null;
}
